<div class="fulfillmentLanding">
  <h3 class="margin-b15">Seed Fulfillment</h3>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <app-efulfillmentfilter [filters]="filterArray" (SearchFilter)="filterGrid($event)" [IsFulfilmentTab]='true'></app-efulfillmentfilter>
    </div>
  </div>
  <mat-tab-group disableRipple [animationDuration]="'400ms'" class="matTabs" (selectedTabChange)="tabChanged($event)">
    <mat-tab>
      <ng-template mat-tab-label>
        <i class="icon-ico-grower_icon" aria-hidden="true"></i>
        <div class="tab-head">
          <h4>
            Unsubmitted Drafts
          </h4>
          <p class="subhead">
            Requests not submitted for dispatch
          </p>
        </div>
      </ng-template>
      <div class="fulfill-top-sec">
        <div class="row listing-action-items">
          <div class="col-xl-4 col-lg-4 col-md-3 smallPadRgt0 margin-l-8">
            <div class="selectAllcheckSec">
              <mat-checkbox (change)="$event ? masterToggleUnsubmitted() : null"
                            [checked]="unsubmittedSelection.hasValue() && isAllUnsubmittedDraftSelected()"
                            [indeterminate]="unsubmittedSelection.hasValue() && !isAllUnsubmittedDraftSelected()" class="custom-checkbox select-all-check">
              </mat-checkbox>
              <i class="fas fa-sort-down light-gray-arrow" aria-hidden="true"></i>
            </div>
            <div class="action-links display-ib">
              <p *ngIf='(selectedCount>0)' class="display-ib">
                <span class="margin-l5 firstOne" (click)="unsubmitedReleaseToJDE()" matTooltip="Submit to ERP" [matTooltipPosition]="'above'" *ngIf="!accessTypeMode">
                  <i class="fas fa-external-link-alt"></i>
                </span>
                <span class="margin-l5 secondOne" (click)="unsubmitedDeleteAction()" matTooltip="Delete" [matTooltipPosition]="'above'" *ngIf="!accessTypeMode">
                  <i class="icon-ico-trash"></i>
                </span>
                <span class="margin-l5 thirdOne" (click)="getUnSubmittedReport()" matTooltip="Export" [matTooltipPosition]="'above'">
                  <i class="fas fa-file-export"></i>
                </span>
              </p>
            </div>
          </div>
          <div class="col-xl-8 col-lg-8 col-md-9 text-right smallPadLeft0 padding-r10">
            <div class="display-ib wAuto">
              <mat-paginator #unSubmittedPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
            </div>
            <span class="margin-l20 text-right smallPadLeft0 smallMarLeft0 valignTop">
              <button mat-raised-button class="btns" color="primary" (click)="getUnsubmittedDraftList()">Refresh Records</button>
              <button *ngIf="!accessTypeMode" mat-raised-button class="btns margin-l5" color="primary" (click)="addEditSeedFulfillment()">Create Order Release</button>
            </span>
          </div>
        </div>
      </div>
      <div class="tableContainer growertableContainer">
        <table mat-table #unSubmittedTable [dataSource]="unsubmittedDataSource" matSort #unSubmittedSort matSortDirection="desc" class="matTables">
          <ng-container matColumnDef="releaseId">
            <th mat-header-cell *matHeaderCellDef class="chkbox">&nbsp;</th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox #SingleCheck (click)="$event.stopPropagation()"
                            (change)="$event ? unsubmittedCheckEvent(row, SingleCheck._checked) : null"
                            [checked]="unsubmittedSelection.isSelected(row)" class="custom-checkbox select-all-check">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="accountNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="shipTo">Ship To</th>
            <td mat-cell *matCellDef="let element" class="order-info" (click)="navigateToReleaseOrderInfo(element,'U')">
              <p class="grower-name">
                <a>
                  {{element.accountName}}
                  <span *ngIf="element.incidentNumber || element.processingStatus=='F'" class="incidentNumberIcon" matTooltip="{{element.incidentNumber}}" [matTooltipPosition]="'above'">
                    <i class="fas fa-circle"></i>
                  </span>
                </a>
              </p>
              <p>
                {{element.city}}, {{element.state}}
              </p>
            </td>
          </ng-container>

          <!--<ng-container matColumnDef="incidentNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="incidentNumber">&nbsp;</th>
            <td mat-cell *matCellDef="let element">
            </td>
          </ng-container>-->
          <ng-container matColumnDef="branchPlant">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="branch">Branch</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              {{element.branchPlant}}
            </td>
          </ng-container>
          <ng-container matColumnDef="requestDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestedDate">Request Date</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              {{element.requestDate | date:'MM/dd/yyyy' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="dealerReleaseNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="dealerReleaseNo">Release #</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              {{element.dealerReleaseNumber}}
            </td>
          </ng-container>
          <ng-container matColumnDef="totalUnit">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="totalUnits">Total Units</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              {{element.totalUnit}}
            </td>
          </ng-container>
          <!--<ng-container matColumnDef="orderDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderDate">Order Date</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              {{element.orderDate | date:'MM/dd/yyyy' }}
            </td>
          </ng-container>-->
          <ng-container matColumnDef="orderType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderType">Order Type</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              {{element.orderType}}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedunSubmittedColumns;sticky:true;"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedunSubmittedColumns;"></tr>
        </table>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <i class="icon-ico-dealer_icon" aria-hidden="true"></i>
        <div class="tab-head">
          <h4>
            Submitted Requests
          </h4>
          <p class="subhead">
            Requests already submitted
          </p>
        </div>
      </ng-template>
      <div class="fulfill-top-sec">
        <div class="row listing-action-items">
          <div class="col-sm-4 margin-l-8">
            <div class="selectAllcheckSec">
              <mat-checkbox (change)="$event ? masterToggleSubmitted() : null"
                            [checked]="submittedSelection.hasValue() && isAllSubmittedDraftSelected()"
                            [indeterminate]="submittedSelection.hasValue() && !isAllSubmittedDraftSelected()" class="custom-checkbox select-all-check">
              </mat-checkbox>
              <i class="fas fa-sort-down light-gray-arrow" aria-hidden="true"></i>
            </div>
            <div class="action-links display-ib">
              <p *ngIf='(selectedSubmittedCount>0)' class="display-ib">
                <span class="margin-l5" (click)="getSubmittedReport()" matTooltip="Export" [matTooltipPosition]="'above'">
                  <i class="fas fa-file-export"></i>
                </span>
              </p>
            </div>
          </div>
          <div class="col-xl-8 col-lg-8 col-md-8 text-right">
            <div class="display-ib wAuto">
              <mat-paginator #submittedPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
            </div>
            <span class="margin-l20 text-right smallPadLeft0 valignTop">
              <button mat-raised-button class="btns" color="primary" (click)="getSubmittedRequestList()">Refresh Records</button>
            </span>
          </div>
        </div>
      </div>
      <div class="tableContainer dealertableContainer">
        <table mat-table #submittedTable [dataSource]="submittedDataSource" matSort #submittedSort matSortDirection="desc" class="matTables">
          <ng-container matColumnDef="releaseId">
            <th mat-header-cell *matHeaderCellDef class="chkbox">&nbsp;</th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox #SingleCheck (click)="$event.stopPropagation()"
                            (change)="$event ? submittedCheckEvent(row, SingleCheck._checked) : null"
                            [checked]="submittedSelection.isSelected(row)" class="custom-checkbox select-all-check">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="accountNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="shipTo">Ship To</th>
            <td mat-cell *matCellDef="let element" class="order-info" (click)="navigateToReleaseOrderInfo(element,'S')">
              <p class="grower-name">
                <a>{{element.accountName}}</a>
              </p>
              <p>
                {{element.city}}, {{element.state}}
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="branchPlant">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="branch">Branch</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              {{element.branchPlant}}
            </td>
          </ng-container>
          <ng-container matColumnDef="requestDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestedDate">Request Date</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              {{element.requestDate | date:'MM/dd/yyyy' }}
            </td>
          </ng-container>
          <!--<ng-container matColumnDef="orderDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderDate">Order Date</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              {{element.orderDate | date:'MM/dd/yyyy' }}
            </td>
          </ng-container>-->
          <ng-container matColumnDef="dealerReleaseNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="dealerReleaseNo">Release #</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              {{element.dealerReleaseNumber}}
            </td>
          </ng-container>
          <ng-container matColumnDef="totalUnit">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="totalUnits">Total Units</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              {{element.totalUnit}}
            </td>
          </ng-container>
          <ng-container matColumnDef="jdereleaseOrderNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="confirmationNo">Conﬁrmation#</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              {{element.jdereleaseOrderNumber}}
            </td>
          </ng-container>
          <ng-container matColumnDef="orderType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderType">Order Type</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              {{element.orderType}}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedsubmittedColumns;sticky:true;"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedsubmittedColumns;"></tr>
        </table>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
